import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';

import { v4 as uuid } from 'uuid';
import { getLocalTime } from '@qualle-admin/qutil/dist/date';

import axios from 'axios';
import moment from 'moment';
import { uid } from 'uid';
import { filterDocuments } from '@/service/documentFilters';

const state = {
  reservations: [],
  organization_reservations: [],
  organization_agreements: [],
  error: null,
};

const mutations = {
  set_reservations(state, payload) {
    state.reservations = payload;
  },
  set_organization_reservations(state, payload) {
    state.organization_reservations = payload;
  },
  set_organization_agreements(state, payload) {
    state.organization_agreements = payload;
  },
  update_error(state, payload) {
    state.error = payload;
  },
};

const actions = {
  get_reservations: async ({ commit, rootGetters }, payload) => {
    let orgId;
    let inited = false;

    if (payload) {
      orgId = payload;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    }

    if (typeof orgId !== 'undefined') {
      Vue.prototype.$snapshots.$reservations_snapshot = firebase
        .firestore()
        .collection('reservations')
        .where('orgId', '==', orgId)
        .onSnapshot(({ docs }) => {
          const fDocs = filterDocuments(docs);
          const reservations = fDocs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          commit('set_reservations', reservations);

          if (inited) {
          }

          inited = true;
        });
    }
  },
  get_organization_reservations: async ({ commit, rootGetters }, payload) => {
    let orgId;
    let inited = false;

    if (payload) {
      orgId = payload;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    }

    if (typeof orgId !== 'undefined') {
      Vue.prototype.$snapshots.$organization_reservations_snapshot =
        await firebase
          .firestore()
          .collection('reservations')
          .where('requesterOrgId', '==', orgId)
          .onSnapshot(({ docs }) => {
            const fDocs = filterDocuments(docs);
            const reservations = fDocs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }));

            commit('set_organization_reservations', reservations);

            if (inited) {
            }

            inited = true;
          });
    }
  },
  get_organization_agreements: async ({ commit, rootGetters }, payload) => {
    let scac;
    let inited = false;

    if (payload) {
      scac = payload;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].scac !== 'undefined'
    ) {
      scac = rootGetters['auth/get_user'].scac;
    }

    if (typeof scac !== 'undefined') {
      let query = firebase.firestore().collection('reservations');

      query = query.where('scac', 'array-contains', scac);

      Vue.prototype.$snapshots.$organization_agreements_snapshot =
        query.onSnapshot(({ docs }) => {
          const fDocs = filterDocuments(docs);
          const agreements = fDocs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          commit('set_organization_agreements', agreements);

          if (inited) {
          }

          inited = true;
        });
    }
  },
  create_reservation: async ({ commit, dispatch, rootGetters }, payload) => {
    const value = await dispatch('checkApprovedReservations', {
      root: true,
    });
    if (value) {
      const reservationBatch = firebase.firestore().batch();

      try {
        const reservationsToCreate = payload.map(
          async ({
            amount = 0,
            container = '',
            orgId = '',
            ref = '',
            owner = '',
            reservationType = '',
            reqCompany = '',
            reqScac = '',
            reqEmail = '',
            reqName = '',
          }) => {
            const reservationId = uuid();
            const reservationRef = await firebase
              .firestore()
              .collection('reservations')
              .doc(reservationId);
            const {
              company: sellerCompany,
              name: sellerName,
              email: sellerEmail,
              scac: sellerScac,
            } = await (
              await firebase.firestore().collection('users').doc(owner).get()
            ).data();

            const {
              company: requesterCompany,
              email: requesterEmail,
              name: requesterName,
              orgId: requesterOrgId,
              scac: requesterScac,
              user_id: userId,
            } = rootGetters['auth/get_user'] || {
              company: reqCompany,
              email: reqEmail,
              scac: reqScac,
              user_id: null,
              orgId: null,
              name: reqName,
            };
            const containerRef = await firebase
              .firestore()
              .collection('containers')
              .doc(`${container}_${orgId}`)
              .get();

            const containerData = containerRef.data();

            const sellerOrganizationRef = await firebase
              .firestore()
              .collection('organizations')
              .doc(orgId)
              .get();

            const {
              empty_locations: sellerEmptyLocations,
              vendorDetails: sellerVendordetails,
            } = sellerOrganizationRef.data();

            const {
              location: { label: yardLabel },
            } = containerData;

            const details = sellerEmptyLocations.find(
              ({ label: cLabel }) => cLabel === yardLabel
            )?.details;

            let sellerDetails =
              details && details.hoursOfOperation && details.primaryContact
                ? details
                : sellerVendordetails;
            sellerDetails = sellerDetails || null;

            // creating purchaser Details Object
            if (requesterOrgId) {
              const purchaserOrganizationRef = await firebase
                .firestore()
                .collection('organizations')
                .doc(requesterOrgId)
                .get();
              const {
                empty_locations: purchaserEmptyLocations,
                vendorDetails,
              } = purchaserOrganizationRef.data();
              var purchaserDetails =
                purchaserEmptyLocations.find(
                  ({ label: cLabel }) => cLabel === yardLabel
                )?.details || vendorDetails;
              purchaserDetails = purchaserDetails || null;
            } else {
              purchaserDetails = null;
            }

            purchaserDetails = purchaserDetails || null;

            const formatValue = (value) => value.slice(0, 15);
            let signatureRequest = null;
            // create hellosign signature request and add to reservation object

            if (rootGetters['settings/get_is_signature_required']) {
              const {
                data: { message },
              } = await axios.post(
                `${process.env.VUE_APP_DOMAIN}/api/v1/hellosign/signature_request`,
                {
                  signers: [
                    {
                      email_address: requesterEmail,
                      name: requesterName,
                      role: 'Signer',
                    },
                    {
                      email_address: sellerEmail,
                      name: sellerName,
                      role: 'Signer2',
                    },
                  ],
                  custom_fields: [
                    {
                      name: 'Company1',
                      value: formatValue(requesterCompany),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'Company2',
                      value: formatValue(sellerCompany),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'FullName1',
                      value: formatValue(requesterName),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'FullName2',
                      value: formatValue(sellerName),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'Container',
                      value: container,
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'DaySigned',
                      value: moment().date(),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'MonthSigned',
                      value: moment().format('MMMM'),
                      editor: 'Admin',
                      required: true,
                    },
                    {
                      name: 'YearSigned',
                      value: moment().format('YYYY'),
                      editor: 'Admin',
                      required: true,
                    },
                  ],
                  metadata: {
                    type: 'reservation_request',
                    id: reservationId,
                  },
                }
              );

              signatureRequest = message.signature_request;
            }
            const newReservationData = {
              amount,
              id: reservationId,
              created: getLocalTime().format(),
              container: containerData,
              details: {
                sellerDetails,
                purchaserDetails,
              },
              ref,
              status: 'pending',
              name: sellerName,
              orgId,
              requesterOrgId,
              requesterCompany,
              requesterEmail,
              scac: [requesterScac, sellerScac],
              owner: userId,
              originalOwner: owner,
              signature: signatureRequest,
              reservationType,
            };

            reservationBatch.set(reservationRef, newReservationData);

            return newReservationData;
          }
        );

        const reservationRequests = await Promise.all(reservationsToCreate);

        await reservationBatch.commit();

        dispatch(
          'auth/new_notification',
          {
            type: 'notification',
            message: `Created ${reservationRequests.length} reservations`,
          },
          { root: true }
        );

        dispatch('get_reservations');
      } catch (error) {
        commit('update_error', error);
      }
    } else {
      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          error: true,
          message: ` ${
            rootGetters['settings/get_is_signature_required']
              ? 'Please sign previous signature agreements to continue reserving'
              : 'Please complete previous reservations to continue reserving'
          }`,
        },
        { root: true }
      );
    }
  },
  update_reservation: async ({ commit, dispatch }, payload) => {
    const reservationBatch = firebase.firestore().batch();

    try {
      const reservationsToUpdate = payload.map(
        async ({ id, status, canceledBy, description }) => {
          const reservationRef = await firebase
            .firestore()
            .collection('reservations')
            .doc(id);

          let updatedReservation = {};

          if (status === 'incomplete') {
            updatedReservation = { status, description };
          } else if (status === 'canceled') {
            updatedReservation = { status, canceledBy };
          } else {
            updatedReservation = { status };
          }

          reservationBatch.update(reservationRef, updatedReservation);
        }
      );

      const reservationRequests = await Promise.all(reservationsToUpdate);

      await reservationBatch.commit();

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Updated ${reservationRequests.length} reservations`,
        },
        { root: true }
      );

      dispatch('get_reservations');
    } catch (error) {
      commit('update_error', error);
    }
  },
  delete_reservation: async ({ commit, dispatch }, payload) => {
    const batch = firebase.firestore().batch();

    try {
      const reservationsToDelete = payload.map(
        async ({ reservation_id: id }) => {
          const reservationRef = firebase
            .firestore()
            .collection('reservations')
            .doc(id);

          batch.delete(reservationRef, { exists: true });

          return null;
        }
      );

      await batch.commit();

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Deleted ${reservationsToDelete.length} reservations`,
        },
        { root: true }
      );

      dispatch('get_reservations');
    } catch (error) {
      commit('update_error', error);
    }
  },
  get_sign_url: async ({ commit }, payload) => {
    try {
      const signatureId = payload;

      const {
        data: { message: signUrl },
      } = await axios.post(
        `${process.env.VUE_APP_DOMAIN}/api/v1/hellosign/sign_url`,
        {
          signatureId,
        }
      );

      return signUrl;
    } catch (error) {
      commit('update_error', 'Agreement already signed');
    }
  },
  confirm_payment: async ({ commit, dispatch, rootGetters }, payload) => {
    const { id, container } = payload;

    try {
      const organizationRef = firebase
        .firestore()
        .collection('organizations')
        .doc(rootGetters['auth/get_user'].orgId);

      const { owner_uid: ownerUid } = await (
        await organizationRef.get()
      ).data();

      const { docs: payments } = await firebase
        .firestore()
        .collection('stripe_customers')
        .doc(ownerUid)
        .collection('payments')
        .where('metadata.reservation', '==', id)
        .get();

      const payment = payments[0].data();

      await axios.post(
        `${process.env.VUE_APP_DOMAIN}/api/v1/stripe/payments/confirm`,
        {
          customerId: ownerUid,
          payment,
        }
      );

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Confirmed container received: ${container}`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  download_agreement: async ({ commit }, payload) => {
    const { signature_request_id: signatureRequestId } = payload;

    try {
      const {
        data: {
          message: { file_url: fileUrl },
        },
      } = await axios.post(
        `${process.env.VUE_APP_DOMAIN}/api/v1/hellosign/download`,
        {
          signatureRequestId,
        }
      );

      window.open(fileUrl);
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Storing data into pending_reservation collection and return the reservation url
  create_pending_reservation: async ({ commit }, payload) => {
    const { container } = payload;
    const url = await firebase
      .firestore()
      .collection('pending_reservations')
      .doc(container)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          const token = uid();
          const reservationData = { ...payload, token };
          firebase
            .firestore()
            .collection('pending_reservations')
            .doc(container)
            .set(reservationData);
          return `${process.env.VUE_APP_CANONICAL_URL}/reservations/${token}`;
        } else {
          return `${process.env.VUE_APP_CANONICAL_URL}/reservations/${
            doc.data().token
          }`;
        }
      });
    return url;
  },
  checkApprovedReservations: ({ getters }) => {
    if (
      getters.get_organization_reservations.findIndex(
        (val) => val.status === 'approved'
      ) === -1
    ) {
      return true;
    } else {
      return false;
    }
  },

  checkPendingReservations: ({ getters }, payload) => {
    const containers = payload.map(({ container }) => container);

    if (
      getters.get_organization_reservations.some(
        ({ container: { container }, status }) =>
          status === 'pending' && containers.includes(container)
      )
    ) {
      return true;
    } else {
      return false;
    }
  },
};

const getters = {
  get_reservations(state) {
    return state.reservations;
  },
  get_organization_reservations(state) {
    return state.organization_reservations;
  },
  get_organization_agreements(state) {
    return state.organization_agreements;
  },
  get_error: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
